import { DisplayWarnings } from '../DisplayWarnings';
import { getProgramName } from '../utils';
import { showProgramSummary } from '../summary/ProgramSummary';
import { PageNotFound } from '@/app/core/components/PageNotFound';
import {
  ProgramWizard,
  ProgramWizardContainer,
} from '@/app/core/components/program-wizard';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { Switch, Route } from 'react-router-dom';
import {
  AscendUSAAProgram,
  PackageNameEnum,
  ProductNameEnum,
} from '@ssar-app/domain';
import { usePathContext } from '@ssar-app/okta-authn-react';

export const CreateProgram = () => {
  const { buildPath } = usePathContext();
  const featureCode = getCurrentFeatureCode();
  return (
    <Switch>
      <Route path={buildPath('/program/create')}>
        <ProgramWizardContainer
          productName={featureCode as ProductNameEnum}
          packageName={'' as PackageNameEnum}
          header={<ProgramWizard.Header></ProgramWizard.Header>}
          footer={<ProgramWizard.Footer></ProgramWizard.Footer>}
          warnings={(messages) => {
            return <DisplayWarnings messages={messages} />;
          }}
          handlers={{
            programNameExtractor: (model) =>
              getProgramName(model as AscendUSAAProgram),
            summaryHandler: (model, ...rest) =>
              showProgramSummary(model as AscendUSAAProgram, ...rest),
          }}
        >
          {(stepWizardProps, _dataStoreState) => {
            return <>{stepWizardProps.steps}</>;
          }}
        </ProgramWizardContainer>
      </Route>
      <Route path='*'>
        <PageNotFound />
      </Route>
    </Switch>
  );
};
